<template>
	<Modals
		:title="'Comment'"
		:display="display"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		@show="close"
	>
		<template #modal-content>
			<div
				class="error-log__resolved"
				v-if="['resolved', 'unresolved'].includes(action)"
			>
				You will
				{{
					['resolved', 'unresolved'].includes(action)
						? action === 'resolved'
							? 'resolve'
							: 'unresolve'
						: action
				}}
				{{ errorsToResolve }}
				{{ errorsToResolve === 1 ? 'error' : 'errors' }}.
			</div>
			<div class="error-log__comment">
				{{
					!['resolved', 'unresolved'].includes(action)
						? capitalizeFirstLetter(action)
						: 'Add'
				}}
				a comment to provide information for other users this will
				replace previous comments.
			</div>
			<div v-if="!isReadOnly">
				<Textarea
					:className="'textarea__input'"
					placeholder="Add a comment about the change"
					:rows="5"
					:cols="30"
					:maxLength="1500"
					:required="true"
					v-model="comment"
					:forceCustomErrorMessage="errorLogCustomErrorMessage"
					@input="setErrorLog"
				/>
			</div>
			<div v-else class="error-log__readonly-comment">
				{{ comment }}
			</div>
			<div
				class="error-log__comment-by"
				v-if="['read', 'edit'].includes(action) && resolvedComment"
			>
				Added by {{ errorLogInfo.resolvedUserId }} on
				{{ shortDateString(errorLogInfo.resolvedTimestamp) }} at
				{{ timeAndTimeZone(errorLogInfo.resolvedTimestamp) }}
			</div>
		</template>
		<template #modal-footer>
			<ButtonGroup :items="buttonItems" />
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import ButtonGroup from '@/components/forms/button/button-group';
import Textarea from '@/components/forms/textarea/textarea.vue';
import DateTimeMixin from '@/mixins/datetime-mixin';
import { required } from 'vuelidate/lib/validators';

export default {
	name: 'ErrorLogCommentSaveModal',
	components: {
		Modals,
		Textarea,
		ButtonGroup
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	mixins: [DateTimeMixin],
	props: {
		display: {
			type: Boolean,
			default: false
		},
		resolvedComment: {
			type: String,
			default: ''
		},
		action: {
			type: String,
			required: true
		},
		errorsToResolve: {
			type: Number,
			default: 0
		},
		selectedIds: {
			type: Array,
			default: () => []
		},
		errorLogInfo: {
			type: Object,
			default: () => ({})
		}
	},
	validations: {
		comment: {
			required
		}
	},
	data() {
		return {
			comment: '',
			hasError: false
		};
	},
	computed: {
		buttonItems() {
			const cancelButton = {
				id: 'cancelButtonModal',
				labelText: this.isReadOnly ? 'Close' : 'Cancel',
				btnClick: this.close
			};

			if (this.isReadOnly) {
				return [cancelButton];
			}
			return [
				{
					id: 'saveButtonModal',
					className: 'btn--primary',
					labelText: 'Save',
					type: 'submit',
					btnClick: this.saveComment,
					disabled: this.hasError || this.hasSameComment
				},
				cancelButton
			];
		},
		isReadOnly() {
			return this.action === 'read';
		},
		errorLogCustomErrorMessage() {
			if (this.$v.comment.$dirty) {
				if (!this.$v.comment.required) {
					return 'Comment is required';
				} else {
					return '';
				}
			} else {
				return '';
			}
		},
		hasSameComment() {
			return this.comment?.trim() === this.resolvedComment?.trim();
		}
	},
	methods: {
		saveComment(e) {
			if (e) e.preventDefault();
			this.$emit('save', this.comment?.trim());
			this.close();
		},
		close() {
			this.comment = '';
			this.$emit('show', false);
			if (this.selectedIds.length === 1) {
				this.$emit('backToogleData', this.selectedIds[0]);
			}
		},
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		setErrorLog() {
			this.$v.$touch();
			this.hasError = !this.$v.comment.required;
		}
	},
	watch: {
		display: {
			deep: true,
			handler(val) {
				if (val && this.resolvedComment) {
					this.comment = this.resolvedComment;
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
  #BASE
\*------------------------------------*/
::v-deep .modal {
	@include mq($from: md) {
		width: 640px;
	}
}
::v-deep .modal {
	&__body {
		overflow: initial;
	}
}

.error-log {
	@include mq($from: md) {
		width: 85vw;
	}

	@include mq($from: md-l) {
		width: 75vw;
		max-width: 840px;
	}
	&__resolved {
		@include body-text('regular-emphasis');
		margin-bottom: $gutter-lg;
	}
	&__comment {
		@include body-text('sm');
		margin-bottom: $gutter-lg;
	}
	&__comment-by {
		@include body-text('sm-supporting');
		margin-top: $gutter-sm;
	}
	&__readonly-comment {
		overflow-y: auto;
		max-height: 200px;
		padding: $gutter-sm;
		text-align: justify;
		@include body-text('regular');
		@include scrollbar;
	}
}
</style>
